export default __webpack_public_path__ + "static/char-s-30-ko-1d8c4c4b0851c8f2ced5de75c7fa1ca1.webp";